import { render, staticRenderFns } from "./OpportunityCreation.vue?vue&type=template&id=bb801b64&"
import script from "./OpportunityCreation.vue?vue&type=script&lang=js&"
export * from "./OpportunityCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports